import { render, staticRenderFns } from "./BrkRefHelplist.vue?vue&type=template&id=7efcdff1&"
import script from "./BrkRefHelplist.vue?vue&type=script&lang=js&"
export * from "./BrkRefHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports